
import ProjectList from "./list";


if (document.body.getAttribute("data-current-path") === "customer/projects") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new ProjectList();
    }
}